<template>

  <div class="lotti-tracker-module">

    <div class="lotti-module-title">
      Stoppuhr
      <span class="lotti-module-subtitle">(nicht berechenbar)</span>
    </div>

    <el-select
        class="lotti-module-tracker-category"
        v-model="category"
        filterable
        size="small"
        @change="updateRunningSession()"
        placeholder="Kategorie wählen">
      <el-option-group
          v-for="group in categoryOptions"
          :key="group.label"
          :label="group.label">
        <el-option
            v-for="item in group.options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-option-group>
    </el-select>

    <el-input
        size="small"
        maxlength="200"
        class="lotti-module-tracker-comment"
        placeholder="Kommentar"
        @change="updateRunningSession()"
        v-model="comment">
    </el-input>

    <el-button
        class="lotti-module-tracker-button"
        type="primary"
        size="small"
        :loading="isLoading"
        @click="toggleButton">
      {{ buttonName.prefix + buttonName.suffix }}
    </el-button>

  </div>

</template>

<script>
import Vue, {VueInstance} from "../../main";
import auth from "../../auth";
import sessionHelper from "../../Helpers/SessionHelper";
import datePickerHelper from "../../Helpers/DatePickerHelper";
import notification from "../../Helpers/NotificationHelper";

export default {

  data() {
    return {
      auth: auth,

      isTicking: false,
      buttonName: {
        prefix: '',
        suffix: 'Start'
      },
      startedAt: null,
      trackerTimeout: null,

      isLoading: false,

      //input fields
      sessionId: null,//id of running tracker
      comment: '',
      category: '',
      categoryOptions: sessionHelper.getNonBillableAndDualCategoryTypes(),
    }
  },

  methods: {

    setTickingButtonTitle() {
      let diffInMillis = new Date() - this.startedAt;
      this.buttonName.prefix = new Date(diffInMillis).toISOString().substr(11, 8)
    },

    toggleButton() {

      //start loading animation
      this.isTicking = !this.isTicking;

      //if timer switched on running
      if (this.isTicking) {

        //set starting datetime
        this.startedAt = new Date();

        //start button timer interval
        this.startButtonTimerInterval();

        //and store the running timer in database
        this.saveRunningSessionOnTimerStart()

      } else {

        //to be sure timeouts are cleared
        clearInterval(this.trackerTimeout);

        //reset button
        this.buttonName.suffix = 'Sending';
        this.buttonName.prefix = '';

        //send to backend
        this.updateStoppedSession();
      }
    },

    startButtonTimerInterval() {

      //set new title
      this.buttonName.suffix = ' - Stop'

      //update button title initially
      this.setTickingButtonTitle();

      //and update button title all second
      this.trackerTimeout = setInterval(() => {
        this.setTickingButtonTitle();
      }, 1000);
    },

    updateStoppedSession() {

      //set button to sending
      this.isLoading = true;

      Vue.http.post(
          'api/v1/session/update',
          {
            therapist_id: this.auth.user.profile.id,
            datetime_start: datePickerHelper.formatUTCDateTimeUS(this.startedAt),
            datetime_end: datePickerHelper.formatUTCDateTimeUS(new Date()),
            category: this.category,
            text: this.comment,
            id: this.sessionId
          }
      ).then(response => {

        //reset fields and button name
        this.resetFields();
        this.buttonName.suffix = 'Start';
        this.isLoading = false;

        //show success msg
        notification.showSuccess(this, 'Zeiteintrag wurde erfolgreich gespeichert');

        //emmit event for all listening components/modules to reload data
        VueInstance.$emit('createdSession', {});

      }, error => {
        this.buttonName.suffix = 'Start';
        this.isLoading = false;
        notification.showError(this, 'Zeiteintrag konnte nicht gespeichert werden');
      })
    },

    updateRunningSession() {
      //only if the timer is running
      if (this.isTicking) {
        Vue.http.post(
            'api/v1/session/update',
            {
              therapist_id: this.auth.user.profile.id,
              datetime_start: datePickerHelper.formatUTCDateTimeUS(this.startedAt),
              datetime_end: null,
              category: this.category,
              timer_on: true,
              text: this.comment,
              id: this.sessionId
            }
        ).then(response => {
          //nothing
        }, error => {
          //nothing
        })
      }
    },

    saveRunningSessionOnTimerStart() {
      Vue.http.post(
          'api/v1/session/create',
          {
            therapist_id: this.auth.user.profile.id,
            datetime_start: datePickerHelper.formatUTCDateTimeUS(this.startedAt),
            datetime_end: null,
            category: this.category,
            timer_on: true,
            text: this.comment,
          }
      ).then(response => {
        //store the sessionId of the running session/timer
        this.sessionId = response.data.id
      }, error => {
        //nothing
      })
    },

    getRunningSession() {

      Vue.http.get(
          'api/v1/session/get-running-timer'
      ).then(response => {

        //if timer is running
        if (response.data.timerOn) {

          //prepare data
          let date = response.data.datetimeStart;//date with "2020-12-22T12:26:24Z" Z at end
          let localDate = date.substring(0, date.length - 1);//"2020-12-22T12:26:24" date without Z

          //apply all needed data
          this.startedAt = new Date(localDate);
          this.category = response.data.category;
          this.comment = response.data.text;
          this.sessionId = response.data.id;

          //set timer is running
          this.startButtonTimerInterval()
          this.isTicking = true;
        }
      }, error => {

      })
    },

    //set input fields to default
    resetFields() {
      this.comment = '';
      this.category = 'n_wb';
    }
  },

  beforeMount() {
    this.getRunningSession()
  },

  beforeDestroy() {
    //to be sure timeouts are cleared
    clearInterval(this.trackerTimeout);
  },

  mounted() {
    this.resetFields();
  }
}

</script>